import type { ActivityEventType } from '@/api/activity'

const VERSION_EVENTS = new Set<ActivityEventType>([
  'version_approved',
  'version_rejected',
  'version_released',
  'version_scheduled',
])

export interface ActivityDestination {
  href: string
  /** 有版本 ID 时，进入版本页后打开这一版的配置抽屉 */
  version_id?: string
}

/** 抽屉里点一条动态的去向。没有应用 ID、或事件类型不认识时不可点。 */
export function activityDestination(item: {
  app_id: string
  event_type?: ActivityEventType
  version_id?: string
}): ActivityDestination | null {
  if (!item.app_id || !item.event_type) return null
  if (item.event_type === 'scope_opened') {
    return { href: `/apps/${item.app_id}/scope` }
  }
  if (VERSION_EVENTS.has(item.event_type)) {
    return {
      href: `/apps/${item.app_id}/versions`,
      version_id: item.version_id || undefined,
    }
  }
  return null
}
